<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";

  export let sortFilter: { [key: string]: any };
  export let colName: string;
  export let displayInline: string = "";

  function changeSort(dir: any) {
    sortFilter.sortCallBack({
      order: colName,
      direction: dir,
    });
  }
</script>

{#if sortFilter.type != colName}
  <Icon
    type="DoubleArrow"
    width="14"
    height="18"
    extraClassNames="margin-left--smallest cursor-pointer sort-control-{colName}-unselected {displayInline}"
    onPress={() => changeSort("DESC")}
    fill="#d9d9d9"
  />
{:else if sortFilter.direction == "DESC"}
  <Icon
    type="SortArrow"
    width="14"
    height="18"
    extraClassNames="margin-left--smallest cursor-pointer sort-control-{colName}-DESC {displayInline}"
    onPress={() => changeSort("ASC")}
  />
{:else}
  <Icon
    type="SortArrow"
    transform={"rotate(180deg);"}
    width="14"
    height="18"
    extraClassNames="margin-left--smallest cursor-pointer sort-control-{colName}-ASC {displayInline}"
    onPress={() => changeSort("DESC")}
  />
{/if}
